import React, { useState } from "react";
import styles from "./styles.module.scss";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

function SlideArchiveFaults({ selectedFault }) {
  const [archiveFaults] = useState(
    selectedFault?.resolved_faults ? [...selectedFault.resolved_faults].reverse() : []
  );

  return (
    <div style={{ height: "100%" }}>
      {archiveFaults.length <= 0 ? (
        <h3 className={styles.archive__text} style={{ marginTop: 10 }}>
          The fault archive is empty
        </h3>
      ) : (
        <div style={{ height: "90%", overflow: "auto" }}>
          {archiveFaults.map((item, index) => (
            <Box key={index} sx={{ width: "100%" }}>
              <Box className={styles.archive}>
                <Box className={styles.archive__box}>
                  <Typography className={styles.archive__text}>{item.system}</Typography>
                  <Typography className={styles.archive__text}>{item.fault_id}</Typography>
                </Box>
                <Typography className={styles.archive__text}>{item.fault}</Typography>
                <Typography className={styles.archive__text}>{item.fix_notes}</Typography>
                <Box className={styles.archive__box}>
                  <Typography className={styles.archive__text}>Добавлен</Typography>
                  <Typography className={styles.archive__text}>{item.reported_at}</Typography>
                </Box>
                <Box className={styles.archive__box}>
                  <Typography className={styles.archive__text}>Устранен</Typography>
                  <Typography className={styles.archive__text}>{item.resolved_at}</Typography>
                </Box>
                <Box className={styles.archive__box}>
                  <Typography className={styles.archive__text}>Добавил</Typography>
                  <Typography className={styles.archive__text}>{item.reported_by}</Typography>
                </Box>
                <Box className={styles.archive__box}>
                  <Typography className={styles.archive__text}>Устранил</Typography>
                  <Typography className={styles.archive__text}>{item.resolved_by}</Typography>
                </Box>
              </Box>
            </Box>
          ))}
        </div>
      )}
    </div>
  );
}

export default SlideArchiveFaults;
